document.addEventListener('DOMContentLoaded', function () {
  'use strict';

  function initBoxartStage(stageId, options) {
    var stage = document.getElementById(stageId);
    var boxart;
    var panel;
    var hitbox;
    var state;
    var initialRotateX;
    var initialRotateY;

    if (!stage) {
      return null;
    }

    boxart = stage.querySelector('.boxart');
    panel = stage.closest('.boxart-demo__panel');
    if (!boxart) {
      return null;
    }

    if (panel) {
      hitbox = panel.querySelector('.boxart-demo__panel-hitbox');
      if (!hitbox) {
        hitbox = document.createElement('div');
        hitbox.className = 'boxart-demo__panel-hitbox';
        panel.appendChild(hitbox);
      }
    }

    initialRotateX = (options && typeof options.rotateX === 'number') ? options.rotateX : -40;
    initialRotateY = (options && typeof options.rotateY === 'number') ? options.rotateY : 45;

    state = {
      angularVelocityX: 0,
      angularVelocityY: 0,
      dragging: false,
      rafId: null,
      lastFrameTime: 0,
      pointerId: null,
      startX: 0,
      startY: 0,
      lastPointerX: 0,
      lastPointerY: 0,
      lastPointerTime: 0,
      orientation: [0, 0, 0, 1]
    };

    function degToRad(value) {
      return value * Math.PI / 180;
    }

    function quatNormalize(q) {
      var length = Math.sqrt(q[0] * q[0] + q[1] * q[1] + q[2] * q[2] + q[3] * q[3]);

      if (!length) {
        return [0, 0, 0, 1];
      }

      return [q[0] / length, q[1] / length, q[2] / length, q[3] / length];
    }

    function quatMultiply(a, b) {
      return [
        a[3] * b[0] + a[0] * b[3] + a[1] * b[2] - a[2] * b[1],
        a[3] * b[1] - a[0] * b[2] + a[1] * b[3] + a[2] * b[0],
        a[3] * b[2] + a[0] * b[1] - a[1] * b[0] + a[2] * b[3],
        a[3] * b[3] - a[0] * b[0] - a[1] * b[1] - a[2] * b[2]
      ];
    }

    function quatFromAxisAngle(x, y, z, angle) {
      var half = angle / 2;
      var sinHalf = Math.sin(half);

      return quatNormalize([x * sinHalf, y * sinHalf, z * sinHalf, Math.cos(half)]);
    }

    function applyRotationDelta(pitchRadians, yawRadians) {
      var q = state.orientation;

      if (pitchRadians) {
        q = quatMultiply(quatFromAxisAngle(1, 0, 0, pitchRadians), q);
      }

      if (yawRadians) {
        q = quatMultiply(quatFromAxisAngle(0, 1, 0, yawRadians), q);
      }

      state.orientation = quatNormalize(q);
    }

    function quatToCssMatrix3d(q) {
      var x = q[0];
      var y = q[1];
      var z = q[2];
      var w = q[3];
      var xx = x * x;
      var yy = y * y;
      var zz = z * z;
      var xy = x * y;
      var xz = x * z;
      var yz = y * z;
      var wx = w * x;
      var wy = w * y;
      var wz = w * z;

      return [
        1 - 2 * (yy + zz),
        2 * (xy + wz),
        2 * (xz - wy),
        0,
        2 * (xy - wz),
        1 - 2 * (xx + zz),
        2 * (yz + wx),
        0,
        2 * (xz + wy),
        2 * (yz - wx),
        1 - 2 * (xx + yy),
        0,
        0, 0, 0, 1
      ].join(', ');
    }

    function render() {
      boxart.style.transform = 'matrix3d(' + quatToCssMatrix3d(state.orientation) + ')';
    }

    function setMotionState(isMoving) {
      stage.classList.toggle('boxart-stage--motion', !!isMoving);
    }

    function setPanelDragState(isDragging) {
      if (!panel) {
        return;
      }

      panel.classList.toggle('boxart-demo__panel--dragging', !!isDragging);
    }

    function updateHitbox() {
      var panelRect;
      var stageRect;

      if (!panel || !hitbox) {
        return;
      }

      panelRect = panel.getBoundingClientRect();
      stageRect = stage.getBoundingClientRect();

      hitbox.style.left = (stageRect.left - panelRect.left) + 'px';
      hitbox.style.top = (stageRect.top - panelRect.top) + 'px';
      hitbox.style.width = stageRect.width + 'px';
      hitbox.style.height = stageRect.height + 'px';
    }

    function stopInertia() {
      if (state.rafId !== null) {
        cancelAnimationFrame(state.rafId);
        state.rafId = null;
      }
      state.lastFrameTime = 0;
      if (!state.dragging) {
        setMotionState(false);
      }
    }

    function startInertia() {
      function step(timestamp) {
        var dt;
        var decay;

        if (state.dragging) {
          state.rafId = null;
          state.lastFrameTime = 0;
          return;
        }

        if (!state.lastFrameTime) {
          state.lastFrameTime = timestamp;
        }

        dt = Math.min((timestamp - state.lastFrameTime) / 16.6667, 2);
        state.lastFrameTime = timestamp;

        applyRotationDelta(state.angularVelocityX * dt, state.angularVelocityY * dt);

        render();

        decay = Math.pow(0.92, dt);
        state.angularVelocityX *= decay;
        state.angularVelocityY *= decay;

        if (Math.abs(state.angularVelocityX) < 0.0004 && Math.abs(state.angularVelocityY) < 0.0004) {
          state.angularVelocityX = 0;
          state.angularVelocityY = 0;
          state.rafId = null;
          state.lastFrameTime = 0;
          setMotionState(false);
          return;
        }

        state.rafId = requestAnimationFrame(step);
      }

      if (state.rafId === null && (Math.abs(state.angularVelocityX) >= 0.0004 || Math.abs(state.angularVelocityY) >= 0.0004)) {
        setMotionState(true);
        state.rafId = requestAnimationFrame(step);
      }
    }

    function onPointerMove(event) {
      var now;
      var dt;
      var moveDx;
      var moveDy;
      var pitchDelta;
      var yawDelta;

      if (!state.dragging || event.pointerId !== state.pointerId) {
        return;
      }

      moveDx = event.clientX - state.lastPointerX;
      moveDy = event.clientY - state.lastPointerY;
      yawDelta = degToRad(moveDx * 0.45);
      pitchDelta = degToRad(-moveDy * 0.35);
      applyRotationDelta(pitchDelta, yawDelta);

      now = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();
      dt = now - state.lastPointerTime;

      if (dt > 0) {
        state.angularVelocityY = yawDelta / (dt / 16.6667);
        state.angularVelocityX = pitchDelta / (dt / 16.6667);
      }

      state.lastPointerX = event.clientX;
      state.lastPointerY = event.clientY;
      state.lastPointerTime = now;

      render();

      if (event.cancelable) {
        event.preventDefault();
      }
    }

    function stopDragging(event) {
      if (!state.dragging || (event && event.pointerId !== state.pointerId)) {
        return;
      }

      state.dragging = false;
      state.pointerId = null;
      stage.classList.remove('boxart-stage--dragging');
      setPanelDragState(false);
      startInertia();

      if (stage.releasePointerCapture && event) {
        try {
          stage.releasePointerCapture(event.pointerId);
        } catch (error) {
          // Ignore pointer capture release failures.
        }
      }
    }

    function onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) {
        return;
      }

      state.dragging = true;
      stopInertia();
      setMotionState(true);
      state.pointerId = event.pointerId;
      state.startX = event.clientX;
      state.startY = event.clientY;
      state.lastPointerX = event.clientX;
      state.lastPointerY = event.clientY;
      state.lastPointerTime = (typeof performance !== 'undefined' && performance.now) ? performance.now() : Date.now();

      stage.classList.add('boxart-stage--dragging');
      setPanelDragState(true);

      if (stage.setPointerCapture) {
        try {
          stage.setPointerCapture(event.pointerId);
        } catch (error) {
          // Ignore pointer capture failures on unsupported targets.
        }
      }

      event.preventDefault();
    }

    function onTouchMove(event) {
      if (!state.dragging) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }
    }

    stage.addEventListener('pointerdown', onPointerDown);
    stage.addEventListener('pointermove', onPointerMove);
    stage.addEventListener('pointerup', stopDragging);
    stage.addEventListener('pointercancel', stopDragging);
    stage.addEventListener('pointerleave', stopDragging);
    stage.addEventListener('touchmove', onTouchMove, { passive: false });

    applyRotationDelta(
      degToRad(initialRotateX),
      degToRad(initialRotateY)
    );
    updateHitbox();
    render();

    window.addEventListener('resize', updateHitbox);

    return {
      stage: stage,
      boxart: boxart,
      destroy: function () {
        stage.removeEventListener('pointerdown', onPointerDown);
        stage.removeEventListener('pointermove', onPointerMove);
        stage.removeEventListener('pointerup', stopDragging);
        stage.removeEventListener('pointercancel', stopDragging);
        stage.removeEventListener('pointerleave', stopDragging);
        stage.removeEventListener('touchmove', onTouchMove);
        setPanelDragState(false);
        stopInertia();
        window.removeEventListener('resize', updateHitbox);
      }
    };
  }

  initBoxartStage('boxart-stage', { rotateX: 0, rotateY: 45 });
  initBoxartStage('boxart-stage-2', { rotateX: 0, rotateY: 45 });
});
